import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { LANGUAGE_CODES, DEFAULT_LANGUAGE, dirOf } from './languages';

import en from './locales/en.json';
import ur from './locales/ur.json';
import ar from './locales/ar.json';
import es from './locales/es.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import hi from './locales/hi.json';

export const LANGUAGE_STORAGE_KEY = 'sa_language';

const resources = {
  en: { translation: en },
  ur: { translation: ur },
  ar: { translation: ar },
  es: { translation: es },
  de: { translation: de },
  fr: { translation: fr },
  hi: { translation: hi },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: LANGUAGE_CODES,
    fallbackLng: DEFAULT_LANGUAGE,
    // A key missing from a locale falls through to English rather than
    // rendering the raw key at the user.
    returnEmptyString: false,
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false }, // React already escapes
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ['localStorage'],
    },
    react: { useSuspense: false },
  });

/** Apply direction + lang to <html> so CSS, screen readers and MUI agree. */
export function applyDocumentLanguage(code) {
  const dir = dirOf(code);
  document.documentElement.setAttribute('lang', code);
  document.documentElement.setAttribute('dir', dir);
  return dir;
}

/** Single entry point for changing language everywhere. */
export function setLanguage(code) {
  if (!LANGUAGE_CODES.includes(code)) return;
  i18n.changeLanguage(code);
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, code);
  } catch {
    /* ignore */
  }
  applyDocumentLanguage(code);
}

applyDocumentLanguage(i18n.resolvedLanguage || DEFAULT_LANGUAGE);

export default i18n;
